const MUTATION_TYPE = {
  setProfile: 'setProfile',
  setUserRoles: 'setUserRoles'
}

const ACTION_TYPE = {
  fetchProfile: 'fetchProfile',
  releaseStudent: 'releaseStudent',
  updateProfile: 'updateProfile',
  changePassword: 'changePassword',
  fetchUserRoles: 'fetchUserRoles'
}

const GETTER_TYPE = {
  getProfile: 'getProfile',
  getUserRoles: 'getUserRoles'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
